module.exports = __webpack_public_path__ + "static/media/my_family_doctor_slider_phone1.bc5438f7.png";